import { useOutletContext } from 'react-router-dom';
import {
  ErrorPageLayout,
  PaginatedTable,
  PaperLayout,
} from '../../../../presentation';
import { QuotesEntityPageContainer } from '../quotes-entity.page.container';
import { GetQuoteQuery } from '@converge/graphql';
import { EXAMPLE_DATA } from './data';
import {
  PoliciesEntityFieldIdType,
  PoliciesEntityFieldLabelType,
} from '@converge/data';
import { useTranslation } from 'react-i18next';
import './quote.detail.policies.scss';

export interface IPoliciesEntityDetails {
  referenceId: string;
  insuredName: string;
  inceptionDate: string;
  endDate: string;
  premium: string | number;
  status: string;
  documentsLink: string;
}
interface IProps {
  quoteDetails: GetQuoteQuery;
  quoteUuid: string;
}

export const QuotesDetailPolicies = () => {
  const { quoteDetails } = useOutletContext<IProps>();
  if (!quoteDetails) {
    return (
      <ErrorPageLayout
        message="No Quote data found"
        messageId="entity.quote.detail.page.NotFound"
      />
    );
  }

  return <QuoteDetailPoliciesInner />;
};

const QuoteDetailPoliciesInner = () => {
  const { t } = useTranslation();
  return (
    <QuotesEntityPageContainer title="Policies">
      <PaperLayout className="quote-detail-policy-layout">
        <PaginatedTable
          columns={[
            {
              id: PoliciesEntityFieldIdType.ReferenceId,
              label: PoliciesEntityFieldLabelType.ReferenceId,
              render: (row: IPoliciesEntityDetails) => row.referenceId,
              isSortable: true,
            },
            {
              id: PoliciesEntityFieldIdType.InsuredName,
              label: PoliciesEntityFieldLabelType.InsuredName,
              render: (row: IPoliciesEntityDetails) => row.insuredName,
              isSortable: true,
            },
            {
              id: PoliciesEntityFieldIdType.InceptionDate,
              label: PoliciesEntityFieldLabelType.InceptionDate,
              render: (row: IPoliciesEntityDetails) => row.inceptionDate,
              isSortable: true,
            },
            {
              id: PoliciesEntityFieldIdType.EndDate,
              label: PoliciesEntityFieldLabelType.EndDate,
              render: (row: IPoliciesEntityDetails) => row.endDate,
              isSortable: true,
            },
            {
              id: PoliciesEntityFieldIdType.Premium,
              label: PoliciesEntityFieldLabelType.Premium,
              render: (row: IPoliciesEntityDetails) => row.premium,
              isSortable: true,
            },
            {
              id: PoliciesEntityFieldIdType.Status,
              label: PoliciesEntityFieldLabelType.Status,
              render: (row: IPoliciesEntityDetails) => row.status,
              isSortable: true,
            },
            {
              id: PoliciesEntityFieldIdType.DocumentsLink,
              label: PoliciesEntityFieldLabelType.DocumentsLink,
              render: (row: IPoliciesEntityDetails) => row.documentsLink,
              isSortable: true,
            },
          ]}
          rows={EXAMPLE_DATA}
          enablePagination={false}
          emptyRowMessage={t(
            'entities.policies.grid.emptyMessage',
            'No policies found'
          )}
        />
      </PaperLayout>
    </QuotesEntityPageContainer>
  );
};
